import React, { useEffect, useReducer } from 'react';
import Flow from 'domains/core/components/Flow/Flow';
import TemplateNameInput from './VoiceCallMessage/TemplateNameInput';
import VoiceCallMessage from './VoiceCallMessage/VoiceCallMessage';
import { voiceTemplateReducer, voiceTemplateInitialState } from './VoiceTemplateReducer';
import SaveExitButton from './SaveExitButton';
import useVoiceTemplateById from 'hooks/queries/useVoiceTemplateById';
import { VoiceTemplateActionType } from './VoiceTemplateActions';
import { ContentType } from 'domains/content/types';
import useQueryParams from 'hooks/useQueryParams';
import useCreateVoiceTemplate from 'hooks/mutations/useCreateVoiceTemplate';
import useUpdateVoiceTemplate from 'hooks/mutations/useUpdateVoiceTemplate';
import { useHistory } from 'react-router';
import { URLPaths } from 'models/enums';

const CreateVoiceTemplateFlow = () => {
    const [state, dispatch] = useReducer(voiceTemplateReducer, voiceTemplateInitialState);

    const query = useQueryParams();
    const voiceTemplateId = query.get('id');
    const parentFolderId = query.get('parentFolderId');
    const isCopy = query.get('isCopy') === 'true';

    const history = useHistory();
    const { data, isSuccess, isLoading } = useVoiceTemplateById({
        voiceTemplateId: voiceTemplateId,
        type: ContentType.VOICE,
        reactQueryOptions: {
            enabled: !!voiceTemplateId,
        },
    });

    const { mutate: createTemplate, isLoading: isCreateLoading, isError: isCreateError } = useCreateVoiceTemplate({
        onSuccess: () => {
            history.push(`${URLPaths.CONTENT}${parentFolderId ? `/${parentFolderId}` : ''}`);
        },
    });

    const { mutate: updateTemplate, isLoading: isUpdateLoading, isError: isUpdateError } = useUpdateVoiceTemplate(
        voiceTemplateId,
        {
            onSuccess: () => {
                history.push(`${URLPaths.CONTENT}${parentFolderId ? `/${parentFolderId}` : ''}`);
            },
        }
    );

    useEffect(() => {
        if (isSuccess && data) {
            dispatch({
                type: VoiceTemplateActionType.SET_TEMPLATE_NAME,
                payload: isCopy ? `Copy of ${data.name}` : data.name,
            });

            dispatch({
                type: VoiceTemplateActionType.SET_GRAPH,
                payload: data.voiceJson,
            });
        }
    }, [isSuccess, data, isCopy]);

    const handleOnSave = () => {
        const mutateInput = {
            voiceTemplateName: state.templateName?.length === 0 ? 'Untitled' : state.templateName,
            voiceJson: state.voiceTemplateFlowState,
            parentFolderId: Number(parentFolderId),
        };

        voiceTemplateId && !isCopy
            ? updateTemplate({ id: voiceTemplateId, ...mutateInput })
            : createTemplate(mutateInput);
    };

    return (
        <div>
            <Flow
                topLeft={
                    <TemplateNameInput
                        voiceTemplateState={state}
                        voiceTemplateDispatchAction={dispatch}
                        isMessageLoading={isLoading}
                    />
                }
                topRight={
                    <SaveExitButton
                        handleOnSave={handleOnSave}
                        isLoading={isCreateLoading || isUpdateLoading}
                        isError={isCreateError || isUpdateError}
                        voiceTemplateState={state}
                    />
                }
                bottomLeft={
                    <VoiceCallMessage
                        voiceTemplateState={state}
                        voiceTemplateDispatchAction={dispatch}
                        isMessageLoading={isLoading}
                    />
                }
            />
        </div>
    );
};

export default CreateVoiceTemplateFlow;
